<template>
  <ProjectList />
</template>

<script>
import ProjectList from "../components/ProjectList.vue";

export default {
  components: { ProjectList },
};
</script>
